import { render, staticRenderFns } from "./InstrumentoSiee.vue?vue&type=template&id=16a89595&"
import script from "./InstrumentoSiee.vue?vue&type=script&lang=js&"
export * from "./InstrumentoSiee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports